module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/aleg2-f40bedf4fe86927cc9e0e06856d0cc06.jpg";